import { GenericError } from '../../../../common/Error/GenericError';
import { LoadingIndicator } from '../../../../common/LoadingIndicator/LoadingIndicator';
import { SupplierNotificationSettings } from '../SupplierNotificationSettings';
import { useSupplierSettings } from '../useSupplierSettings';

interface SupplierCommunicationPreferencesTabProps {
    companyId: string;
}

export const SupplierCommunicationPreferencesTab = ({ companyId }: SupplierCommunicationPreferencesTabProps) => {
    const supplierSettingsQuery = useSupplierSettings(companyId);

    if (supplierSettingsQuery.isPending) {
        return <LoadingIndicator />;
    }

    if (supplierSettingsQuery.isError) {
        return <GenericError />;
    }

    return <SupplierNotificationSettings supplierSettings={supplierSettingsQuery.data} supplierId={companyId} />;
};
